<template>
    <c-dialog ref="dialog" title="产品详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.product_code" class="m-detail-tag flex-center-cross">
                <label>{{detailData.spec_model}}</label>
                <c-state dict="disableEnableDic" tag :value="detailData.is_enabled"></c-state>
            </div>
        </template>

        <div class="m-detail-box">
            <c-title>基本信息</c-title>
            <c-detail column="2">
                <c-detail-item label="产品编码">
                    {{detailData.product_code}}
                </c-detail-item>
                <c-detail-item label="规格型号">
                    {{detailData.spec_model}}
                </c-detail-item>
                <c-detail-item label="物料类型">
                    {{detailData.material_type}}
                </c-detail-item>
                <c-detail-item label="物料类型名称">
                    {{detailData.material_type_name}}
                </c-detail-item>
                <c-detail-item label="一级分类">
                    {{detailData.first_category_code}}
                </c-detail-item>
                <c-detail-item label="一级分类名称">
                    {{detailData.first_category_name}}
                </c-detail-item>
                <c-detail-item label="二级分类">
                    {{detailData.second_category_code}}
                </c-detail-item>
                <c-detail-item label="二级分类名称">
                    {{detailData.second_category_name}}
                </c-detail-item>
                <c-detail-item label="三级分类">
                    {{detailData.third_category_code}}
                </c-detail-item>
                <c-detail-item label="三级分类名称">
                    {{detailData.third_category_name}}
                </c-detail-item>
                <c-detail-item label="四级分类">
                    {{detailData.fourth_category_code}}
                </c-detail-item>
                <c-detail-item label="四级分类名称">
                    {{detailData.fourth_category_name}}
                </c-detail-item>
                <c-detail-item label="五级分类">
                    {{detailData.fifth_category_code}}
                </c-detail-item>
                <c-detail-item label="五级分类名称">
                    {{detailData.fifth_category_name}}
                </c-detail-item>
                <c-detail-item label="计量单位编码">
                    {{detailData.unit_code}}
                </c-detail-item>
                <c-detail-item label="计量单位名称">
                    {{detailData.unit_name}}
                </c-detail-item>
                <c-detail-item label="基本计量单位">
                    {{detailData.base_unit}}
                </c-detail-item>
                <c-detail-item label="颜色">
                    {{detailData.color}}
                </c-detail-item>
                <c-detail-item label="厚度（毫米）">
                    {{detailData.thickness_mm}}
                </c-detail-item>

                <c-detail-item label="面层花纹">
                    {{detailData.surface_pattern}}
                </c-detail-item>

                <c-detail-item label="基准色">
                    {{detailData.base_color}}
                </c-detail-item>

                <c-detail-item label="启用日期">
                    {{detailData.enable_date}}
                </c-detail-item>

                <c-detail-item label="内消/外销">
                    {{detailData.internal_export}}
                </c-detail-item>
            </c-detail>

            <c-title>记录时间</c-title>
            <c-detail column="2">
                <c-detail-item label="创建日期">
                    {{detailData.create_date}}
                </c-detail-item>
                <c-detail-item label="修改日期">
                    {{detailData.modify_date}}
                </c-detail-item>
                <c-detail-item label="最新同步日期">
                    {{detailData.receive_date}}
                </c-detail-item>
            </c-detail>
        </div>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'productDetail',
    props: {
        id: [String, Number],
        inventory_code: String
    },
    data() {
        return {
            detailData: {}
        }
    },

    computed: {
        ...mapState(['productTypeName', 'openCloseDic', 'disableEnableDic'])
    },

    methods: {
        open() {
            this.request({
                url: '/product/detail',
                data: {
                    id: this.id,
                    inventory_code: this.inventory_code
                },
                loading: true,
                success: data => {
                    this.detailData =  data;
                    this.$refs.dialog.open();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>
